import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './type.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: '',
    bgColor: '#ffffff'
  },
  getters: {
    getCount: state => state.count,
    bgColors: state => state.bgColor
  },
  mutations: {
    [types.GETCOUNT]: (state, data) => {
      state.count = data
    },
    changeBgColor: (state, data) => {
      state.bgColor = data
    }
  },
  modules: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js